<div class="profil" [@fade]="true">
    <div class="container head">
        <div class="row block" id="profile">
            <div class="col-md-12">
                <h3 class="heading">Mes informations personnelles:</h3>
                <button class="btn" *ngIf="!updateInfo" (click)="updateInfo=!updateInfo">
                    <i class="flaticon-edit-document"></i>
                    Modifier
                </button>
                <hr class="half_space">
                <table class="info">
                    <tr>
                        <td>Email :</td>
                        <td>
                            <span *ngIf="!updateInfo">{{customer.email}}</span>
                            <span *ngIf="updateInfo">
                                <input type="text" [(ngModel)]="customer.email" value="">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Nom :</td>
                        <td>
                            <span *ngIf="!updateInfo">{{customer.lastname}}</span>
                            <span *ngIf="updateInfo">
                                <input type="email" [(ngModel)]="customer.lastname" value="">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Prénom :</td>
                        <td>
                            <span *ngIf="!updateInfo">{{customer.firstname}}</span>
                            <span *ngIf="updateInfo">
                                <input type="text" [(ngModel)]="customer.firstname" value="">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Téléphone :</td>
                        <td>
                            <span *ngIf="!updateInfo">{{customer.phone}}</span>
                            <span *ngIf="updateInfo">
                                <input type="tel" [(ngModel)]="customer.phone" value="">
                            </span>
                        </td>
                    </tr>
                    <tr *ngIf="updateInfo">
                        <td>Entrer votre mot de passe pour valider la modification :</td>
                        <td>
                            <span>
                                <input type="password" [(ngModel)]="customer.oldPassword" value="">
                            </span>
                        </td>
                    </tr>
                    <tr *ngIf="updateInfo">
                        <td></td>
                        <td>
                            <div class="valider">
                                <button class="btn" (click)="updateInfo=!updateInfo">Annuler</button>
                                <button class="btn" (click)="updateUser()">Valider</button>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="row block" id="my-address">
            <div class="col-md-12">
                <h3 class="heading">Mes adresses:</h3>
                <button class="btn" (click)="addAddress()">
                    <i class="flaticon-edit-document"></i>
                    Ajouter
                </button>
                <hr class="half_space">
                <div *ngIf="address?.length==0" class="text-center">
                    <p>Aucune adresse pour le moment</p>
                </div>
                <table *ngIf="address?.length>0" class="table-striped" width="100%">
                    <thead>
                        <th class="text-center">Num de la rue</th>
                        <th class="text-center">Nom de la rue</th>
                        <th class="text-center">Code postale</th>
                        <th class="text-center">Batiment</th>
                        <th class="text-center">Escalier</th>
                        <th class="text-center">Etage</th>
                        <th class="text-center">Porte</th>
                        <th class="text-center">Interphone</th>
                        <th class="text-center">Action</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let address of address;let i=index;">
                            <td class="text-center">{{address.streetNumber}}</td>
                            <td class="text-center">{{address.streetName}}</td>
                            <td class="text-center">{{address.postalCode}}</td>
                            <td class="text-center">
                                <span *ngIf="address.building">{{address.building}}</span>
                                <span *ngIf="!address.building">
                                    <strong>-</strong>
                                </span>
                            </td>
                            <td class="text-center">
                                <span *ngIf="address.staircase">{{address.staircase}}</span>
                                <span *ngIf="!address.staircase">
                                    <strong>-</strong>
                                </span>
                            </td>
                            <td class="text-center">
                                <span *ngIf="address.floor">{{address.floor}}</span>
                                <span *ngIf="!address.floor">
                                    <strong>-</strong>
                                </span>
                            </td>
                            <td class="text-center">
                                <span *ngIf="address.door">{{address.door}}</span>
                                <span *ngIf="!address.door">
                                    <strong>-</strong>
                                </span>
                            </td>
                            <td class="text-center">
                                <span *ngIf="address.intercom">{{address.intercom}}</span>
                                <span *ngIf="!address.intercom">
                                    <strong>-</strong>
                                </span>
                            </td>
                            <td class="text-center">
                                <i (click)="editAddress(i)" class="flaticon-edit-document cursor-pointer"></i>
                                <i (click)="openModal(template,i)" class="flaticon-garbage cursor-pointer"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row block" id="change-password">
            <div class="col-md-12">
                <h3 class="heading">Modifier votre mot de passe:</h3>
                <hr class="half_space">
                <p>* minimum 8 caractères </p>
                <table class="info">
                    <tr>
                        <td>Mot de passe actuel * :</td>
                        <td>
                            <span>
                                <input type="password" [(ngModel)]="oldPassword">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Nouveau mot de passe * :</td>
                        <td>
                            <span>
                                <input type="password" [(ngModel)]="customer.password">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Confirmer le nouveau mot de passe * :</td>
                        <td>
                            <span>
                                <input type="password" [(ngModel)]="customer.confirmePassword">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <div class="valider">
                                <button class="btn" (click)="updatePassword()">Valider</button>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>
<ng-template #template>
    <div class="modal-body text-center">
        <p>Voulez-vous supprimer cette adresse?</p>
        <button type="button" class="btn btn-default" (click)="confirm()">Oui</button>
        <button type="button" class="btn btn-send" (click)="decline()">Non</button>
    </div>
</ng-template>